import { useEffect, useState } from "react";
import Auth, { UserIdentity } from "opensooq-sso";
import { parseCookies } from "utils/nookies";
import { CookiesConstants, SSO_ROOT_ELEMENT } from "utils/constants";
import {IMember} from "../screens/AccountMembership/_private/types/midView";
import {SSO_LOGIN_STATE} from "contexts/authSSOContext";
import useGenerateSession from "./useGenerateSession";

export enum EnumLoginState {
  LoggedIn = "LoggedIn",
  LoggedOut = "LoggedOut",
}

export interface ILoginState {
  state: EnumLoginState.LoggedIn | EnumLoginState.LoggedOut;
}

export const useAuthSSO = (
  device: string,
  locale: string,
  country: string,
  hostNoSubDomain: string,
  cityId:number,
  memberData: IMember
) => {
  const [loggedInState, setLoggedInState] = useState<ILoginState>(
    !!Number(memberData?.["id"]) === true
      ? { state: EnumLoginState.LoggedIn }
      : { state: EnumLoginState.LoggedOut }
  );
  const [auth, setAuth] = useState<Auth | null>(null);
  const [userInfo, setUserInfo] = useState<UserIdentity | null>(null);

  const cookies = parseCookies();
  useEffect(() => {
    initAuth().then();
  }, []);

  const initAuth = async () => {
    const newAuth = Auth.getInstance();
    window['ssoInitObject'] = {
      hostNoSubDomain,
      SSO_ROOT_ELEMENT,
      locale,
      country,
      device,
      device_uuid: cookies[CookiesConstants.DEVICE_UUID],
      cityId
    }
    const loginState = await newAuth.init(
        window['ssoInitObject'].hostNoSubDomain,
        window['ssoInitObject'].SSO_ROOT_ELEMENT,
        window['ssoInitObject'].locale,
        window['ssoInitObject'].country,
        window['ssoInitObject'].device,
        window['ssoInitObject'].device_uuid,
        window['ssoInitObject'].cityId
    );
    window[SSO_LOGIN_STATE] = loginState
    setLoggedInState(loginState);
    setAuth(newAuth);
    const getIdentity = await newAuth.getIdentity().then(
        useGenerateSession(newAuth?.auth.deviceUUID)
    );
    setUserInfo(getIdentity);

  };

  return { loggedInState, auth, userInfo };
};
